import type { SalesQuantityModel } from '@/shared/generated'

export type FanChartPoint = {
	date: string
	actual: number | null
	median: number | null
	band50: [number, number] | null
	band90: [number, number] | null
}

export const buildFanChartData = (
	sq: SalesQuantityModel
): { points: FanChartPoint[]; todayDate: string | null } => {
	const points: FanChartPoint[] = sq.history.map((point) => ({
		date: point.date_on,
		actual: point.value,
		median: null,
		band50: null,
		band90: null,
	}))

	const seam = points[points.length - 1]

	if (seam && seam.actual !== null) {
		seam.median = seam.actual
		seam.band50 = [seam.actual, seam.actual]
		seam.band90 = [seam.actual, seam.actual]
	}

	for (const point of sq.forecast) {
		points.push({
			date: point.date_on,
			actual: null,
			median: point.q50,
			band50: [point.q25, point.q75],
			band90: [point.q05, point.q95],
		})
	}

	return { points, todayDate: seam?.date ?? null }
}
